import { usePagination, useQueryString } from '@zeal/zeal-lib';
import { useQuery } from '@app/QueryClient';

import { generatedKeys } from '@app/data/queryKeysFactory';
import { apiDownloads } from '@app/Services/LoyaltyProgramme';
import { useDebugValue } from 'react';
import { TApiExport } from '@modules/LoyaltyProgramme/types';

const { freemiumLoyalty } = generatedKeys;

export default function useDownloads() {
	const [{ page }] = useQueryString();

	const q = useQuery({
		queryKey: freemiumLoyalty?.downloads?.({ page }) as string[],
		staleTime: 1000 * 30 * 1, // 30 sec
		queryFn: apiDownloads,
	});

	const pagination = usePagination({
		pageNum: q?.data?.meta.current_page || 1,
		pagesCount: q?.data?.meta.last_page || 1,
	});

	useDebugValue(q);

	return { ...q, data: q.data?.data as TApiExport[], pagination };
}
